import { apiPost } from './client';
import type { AnswerResponse, ExecuteAnswerRequest } from '@/types/answer';

export async function executeAnswer(body: ExecuteAnswerRequest): Promise<AnswerResponse> {
  return apiPost<AnswerResponse>('/answers/execute', body);
}
